/* Jet Life / Motion + Rebuy integration. Reads/syncs carts; never writes cart items. */
(() => {
  'use strict';
  const node = document.getElementById('JetLifeCartSyncConfig');
  if (!node || window.JetLifeCartSync) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const stats = {version:'1.0.2',requests:0,syncs:0,guardedCallbacks:0,focusRestorations:0,busy:false,lastError:null};
  if (config.guardChat) document.body.classList.add('jlcs-chat-guard');
  const chatDisplay = new WeakMap();
  let dirty = false, wantOpen = false, timer, nativeTimer, lastFingerprint, ownOpen = false, ownNativeClose = false;
  const smart = () => window.Rebuy?.SmartCart;
  const cartModule = () => window.Rebuy?.Cart;
  const nativeOpen = () => document.getElementById('CartDrawer')?.classList.contains('drawer--is-open');
  const fingerprint = c => JSON.stringify([
    c.currency,c.item_count,c.total_price,c.total_discount,c.note,
    (c.items || []).map(i=>[i.key,i.quantity,i.final_line_price,i.selling_plan_allocation?.selling_plan?.id])
  ]);
  const hideChat = () => {
    const chat = document.getElementById('shopify-chat');
    if (!chat) return;
    if (!chatDisplay.has(chat)) chatDisplay.set(chat, {
      value:chat.style.getPropertyValue('display'),
      priority:chat.style.getPropertyPriority('display')
    });
    chat.style.setProperty('display','none');
  };
  const restoreChat = () => {
    const chat = document.getElementById('shopify-chat'), previous = chat && chatDisplay.get(chat);
    if (!previous) return;
    if (previous.value) chat.style.setProperty('display',previous.value,previous.priority);
    else chat.style.removeProperty('display');
    chatDisplay.delete(chat);
  };
  const closeNative = () => {
    // Motion's CartDrawer.close passes a non-element into removeTrapFocus.
    // Its existing close-button path uses Drawers.close with the real DOM element.
    if (config.handoff && nativeOpen()) {
      ownNativeClose = true;
      try { document.querySelector('#CartDrawer .drawer__close-button')?.click(); }
      finally { ownNativeClose = false; }
    }
  };
  const guardCallbacks = () => {
    if (!config.guardChat) return;
    const callbacks = smart()?.settings?.callbacks;
    if (!callbacks) return;
    const squash = s => String(s || '').replace(/\s/g,'').replace(/"/g,"'");
    const legacy = {
      show:"document.querySelector('#shopify-chat').style.display='none';",
      hide:"document.querySelector('#shopify-chat').removeAttribute('style');"
    };
    for (const name of ['show','hide']) {
      if (callbacks[name]?.enabled && squash(callbacks[name].function) === legacy[name]) {
        callbacks[name].function = name === 'show'
          ? 'window.JetLifeCartSync.hideChat();'
          : 'window.JetLifeCartSync.restoreChat();';
        stats.guardedCallbacks++;
      }
    }
  };
  const warning = show => {
    const slot = document.querySelector('.rebuy-cart__flyout [data-app-target="below_subtotal"]');
    if (!slot) return;
    let note = slot.querySelector('[data-jlcs-warning]');
    if (!show) { note?.remove(); return; }
    if (note) return;
    note = document.createElement('div'); note.className = 'jlcs-warning'; note.dataset.jlcsWarning = ''; note.setAttribute('role','status');
    const message = document.createElement('p'); message.textContent = config.warning;
    const link = document.createElement('a'); link.href = config.cartUrl; link.textContent = config.warningLink;
    note.append(message,link); slot.append(note);
  };
  const updateNative = c => {
    if (!c?.items) return;
    document.querySelectorAll('.cart-link__bubble').forEach(el=>el.classList.toggle('cart-link__bubble--visible',c.item_count > 0));
    const next = fingerprint(c), changed = lastFingerprint !== undefined && lastFingerprint !== next;
    lastFingerprint = next;
    if (changed && (document.getElementById('CartDrawerForm') || document.getElementById('CartPageForm'))) {
      clearTimeout(nativeTimer);
      nativeTimer = setTimeout(()=>document.dispatchEvent(new CustomEvent('cart:build')),80);
    }
  };
  const handoff = () => {
    if (!config.handoff || smart()?.status !== 'ready') return;
    closeNative();
    if (!smart().visible) {
      ownOpen = true;
      try { smart().show(); } finally { ownOpen = false; }
    }
  };
  const run = () => {
    clearTimeout(timer); timer = undefined;
    guardCallbacks();
    const api = cartModule();
    if (stats.busy || !dirty || typeof api?.fetchShopifyCart !== 'function' || api.status !== 'ready') return;
    stats.busy = true; dirty = false; stats.requests++;
    let finished = false;
    const done = (c,error) => {
      if (finished) return;
      finished = true; clearTimeout(timeout); stats.busy = false;
      if (error || !c?.items) {
        stats.lastError = 'Cart refresh could not be confirmed.';
        wantOpen = false; warning(true);
      } else {
        stats.syncs++; stats.lastError = null; updateNative(c); warning(false);
        if (dirty) { timer = setTimeout(run,60); return; }
        if (wantOpen) { wantOpen = false; handoff(); }
      }
      if (dirty) timer = setTimeout(run,120);
    };
    const timeout = setTimeout(()=>done(null,true),8000);
    try { api.fetchShopifyCart(c=>done(c)); } catch (_) { done(null,true); }
  };
  const request = open => {
    dirty = true; wantOpen = wantOpen || Boolean(open);
    clearTimeout(timer); timer = setTimeout(run,60);
  };
  const onShow = () => {
    guardCallbacks();
    if (config.guardChat) hideChat();
    closeNative();
    if (!stats.busy && !ownOpen) request(false);
  };
  const ready = () => {
    guardCallbacks();
    updateNative(cartModule()?.getCart?.());
    if (dirty || nativeOpen()) request(Boolean(nativeOpen()));
  };
  // Public diagnostic surface intentionally excludes customer data and cart tokens.
  window.JetLifeCartSync = Object.freeze({
    hideChat,restoreChat,
    get diagnostics() { return {...stats,pending:dirty}; }
  });
  document.addEventListener('ajaxProduct:added',()=>request(true));
  document.addEventListener('cart:updated',()=>request(false));
  document.addEventListener('drawerOpen.CartDrawer',()=>{
    if (smart()?.visible) closeNative();
    request(true);
  });
  // Motion does not emit a drawerClose event. Respect its real closing gestures.
  document.addEventListener('click',event=>{
    if (!event.target?.closest) return;
    if (!ownNativeClose && nativeOpen() && (
      event.target.closest('#CartDrawer .js-drawer-close') || !event.target.closest('#CartDrawer')
    )) wantOpen = false;
  },true);
  document.addEventListener('keydown',event=>{
    if (event.key === 'Escape' && nativeOpen()) wantOpen = false;
  },true);
  // Motion's delayed close callback focuses its cart trigger. While Rebuy is
  // visible, return that specific focus target to the dialog, not to the header.
  // Do not override theme methods or interfere with fields already in the cart.
  document.addEventListener('focusin',event=>{
    if (!smart()?.visible || !event.target?.closest?.('a.js-drawer-open-cart')) return;
    const close = document.querySelector('#rebuy-cart .rebuy-cart__flyout-close');
    if (close) {close.focus({preventScroll:true});stats.focusRestorations++;}
  });
  ['rebuy:smartcart.init','rebuy:smartcart.ready','rebuy:cart.ready'].forEach(name=>document.addEventListener(name,ready));
  document.addEventListener('rebuy:smartcart.show',onShow);
  document.addEventListener('rebuy:smartcart.hide',()=>{
    wantOpen = false;
    if(config.guardChat)restoreChat();
  });
  document.addEventListener('rebuy:cart.change',()=>{
    updateNative(cartModule()?.getCart?.());
    // Only resume a requested native refresh; never fetch on every Rebuy change.
    if (dirty && !stats.busy) {clearTimeout(timer);timer=setTimeout(run,100);}
  });
  window.addEventListener('pageshow',e=>{if(e.persisted)request(false);});
  window.addEventListener('focus',()=>{if(smart()?.visible)request(false);});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden && smart()?.visible)request(false);});
  ready();
})();
